const getButtonColors = (theme, colorKey) => {
    const colorObj = theme.palette[colorKey];
    const primaryColor = theme.palette.primary;
    // Needed to appease Typechecking
    const isPaletteColor = (obj) => obj !== null &&
        typeof obj === 'object' &&
        'main' in obj &&
        'dark' in obj &&
        'contrastText' in obj;
    return {
        main: isPaletteColor(colorObj) ? colorObj.main : primaryColor.main,
        dark: isPaletteColor(colorObj) ? colorObj.dark : primaryColor.dark,
        contrastText: isPaletteColor(colorObj) ? colorObj.contrastText : primaryColor.contrastText,
    };
};
const getButtonSizeEffects = (size) => {
    const sizeEffects = {
        small: { scaleAmount: 0.94, translateAmount: 1 },
        medium: { scaleAmount: 0.95, translateAmount: 1 },
        large: { scaleAmount: 0.95, translateAmount: 2 },
        xlarge: { scaleAmount: 0.955, translateAmount: 2 },
        giant: { scaleAmount: 0.955, translateAmount: 3 },
    };
    return size && size in sizeEffects ?
        sizeEffects[size] :
        sizeEffects.medium;
};
const getSizeStyles = (size = 'medium') => {
    const sizeStyles = {
        small: {
            padding: '4px 10px',
            fontSize: '0.8125rem',
        },
        medium: {
            padding: '6px 16px',
            fontSize: '0.875rem',
        },
        large: {
            padding: '8px 22px',
            fontSize: '0.9375rem',
        },
        xlarge: {
            padding: '10px 24px',
            fontSize: '1.125rem',
        },
        giant: {
            padding: '20px 26px',
            fontSize: '1.375rem',
        },
    };
    return sizeStyles[size] || sizeStyles.medium;
};
const MuiButtonVariants = [
    {
        props: { size: 'xlarge' },
        style: {
            padding: '16px 24px',
            fontSize: '1.125rem',
        },
    },
    {
        props: { size: 'giant' },
        style: {
            padding: '20px 26px',
            fontSize: '1.375rem',
        },
    },
    {
        props: { variant: 'toggle' },
        style: ({ theme, ownerState }) => {
            const colorKey = (ownerState.color || 'primary');
            const size = ownerState.size || 'medium';
            const colors = getButtonColors(theme, colorKey);
            const { scaleAmount, translateAmount } = getButtonSizeEffects(size);
            const sizeStyles = getSizeStyles(size);
            const baseStyles = {
                backgroundColor: colors.main,
                color: colors.contrastText,
                boxShadow: theme.shadows[5],
                position: 'relative',
                transform: 'scale(1) translateY(0)',
                transformOrigin: 'center',
                transition: theme.transitions.create(['background-color', 'box-shadow', 'transform'], { duration: theme.transitions.duration.shortest }),
                ...sizeStyles,
            };
            const hoverStyles = {
                backgroundColor: colors.dark,
                boxShadow: theme.shadows[5],
            };
            const activeStyles = {
                transform: `scale(${scaleAmount}) translateY(${translateAmount}px)`,
                boxShadow: `inset 0 2px 4px rgba(0,0,0,0.2), ${theme.shadows[3]}`,
            };
            return {
                ...baseStyles,
                '&:hover': hoverStyles,
                '&:active': activeStyles,
                '&.Mui-disabled': {
                    color: '#fff',
                },
            };
        },
    },
];
export default MuiButtonVariants;
//# sourceMappingURL=MuiButtonVariants.js.map